var exports = {
  "a": "Box__CkrVIy",
};

module.exports = exports;
